export function PhotoPlaceholder({
  variant = 'arch',
  label = 'Miejsce na zdjęcie Kasi',
  className = '',
  imageSrc,
  imageAlt,
}: {
  variant?: 'arch' | 'circle' | 'wide'
  label?: string
  className?: string
  imageSrc?: string
  imageAlt?: string
}) {
  if (imageSrc) {
    return (
      <div className={`photo-placeholder photo-placeholder--${variant} photo-placeholder--has-image ${className}`}>
        <img className="photo-placeholder__image" src={imageSrc} alt={imageAlt || label} decoding="async" fetchPriority="high" />
      </div>
    )
  }

  return (
    <div className={`photo-placeholder photo-placeholder--${variant} ${className}`} role="img" aria-label={label}>
      <span className="photo-placeholder__monogram" aria-hidden="true">KS</span>
      <span className="photo-placeholder__label">{label}</span>
    </div>
  )
}
